import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const Section = ({ title, children }) => (
  <section className="mt-10">
    <h2 className="font-display text-2xl font-bold text-white">{title}</h2>
    <div className="mt-3 space-y-3 text-neutral-300 leading-relaxed">{children}</div>
  </section>
);

export default function Terms() {
  useEffect(() => {
    document.title = "Käyttöehdot | Ysitien LED";
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="bg-[#07111F] text-white min-h-screen">
      <div className="mx-auto max-w-3xl px-6 lg:px-10 py-16 md:py-24">
        <Link
          to="/"
          className="inline-flex items-center gap-2 text-sm text-[#22D3EE] hover:text-[#67E8F9] transition-colors"
          data-testid="terms-back"
        >
          <ArrowLeft className="h-4 w-4" /> Takaisin etusivulle
        </Link>

        <h1 className="mt-8 font-display text-4xl md:text-5xl font-bold leading-tight">
          Käyttöehdot
        </h1>
        <p className="mt-3 text-sm text-neutral-500">Päivitetty 3.7.2026</p>

        <Section title="1. Palvelun tarjoaja">
          <p>
            Ysitien LED tarjoaa LED-mainospaikkoja 9-tien varrella Loimaalla.
            Näissä ehdoissa ”palvelu” tarkoittaa Ysitien LED -verkkosivustoa
            ja siihen liittyviä palveluita.
          </p>
        </Section>

        <Section title="2. Yhteydenotot ja tarjoukset">
          <p>
            Sivustolla annetut hinnat (viikko 400 € + alv, kuukausi 1 000 € + alv,
            12 kk 6 000 € + alv) ovat lähtökohtaisia listahintoja. Sitovan
            tarjouksen ja aikataulun voi vahvistaa vasta yhteydenoton jälkeen.
          </p>
        </Section>

        <Section title="3. Mainosaineiston toimittaminen">
          <p>
            Mainostaja vastaa toimitettavan mainosaineiston sisällöstä,
            oikeuksista ja tekijänoikeuksista sekä siitä, että aineisto on
            Suomen lain ja hyvien tapojen mukainen. Palvelulla on oikeus kieltäytyä
            julkaisemasta lainvastaista tai muutoin sopimatonta materiaalia.
          </p>
        </Section>

        <Section title="4. Vastuunrajoitus">
          <p>
            Palvelu pyrkii pitämään LED-taulun toiminnassa keskeytyksettä, mutta
            ei vastaa lyhytaikaisista katkoista, jotka johtuvat esimerkiksi
            sähkökatkoista, huoltotoimista tai ylivoimaisesta esteestä.
          </p>
        </Section>

        <Section title="5. Immateriaalioikeudet">
          <p>
            Sivuston sisältö (tekstit, logot, kuvat, koodi) on Ysitien LED:n tai
            sen kumppaneiden omaisuutta. Sisällön kopiointi ilman lupaa on
            kielletty.
          </p>
        </Section>

        <Section title="6. Sovellettava laki">
          <p>
            Näihin ehtoihin sovelletaan Suomen lakia. Mahdolliset erimielisyydet
            pyritään ensisijaisesti sopimaan neuvotellen. Riidat käsitellään
            Ysitien LED:n kotipaikan käräjäoikeudessa.
          </p>
        </Section>

        <div className="mt-16 border-t border-[#1E2F44] pt-6 text-sm text-neutral-500">
          © {new Date().getFullYear()} Ysitien LED
        </div>
      </div>
    </div>
  );
}
